<template>
  <div class="block sm:hidden">
    <Col gap="sm">
      <slot name="search"></slot>
      <FilterButton @click="drawer = true" />
      <Drawer v-model="drawer" :unmount="false">
        <template v-slot:title>
          <Heading2>{{ app.texts.filter.title }}</Heading2>
        </template>
        <Col gap="lg" class="h-full">
          <Col class="overflow-auto px-1" gap="lg" stretch>
            <slot name="search"></slot>
            <slot name="filters"></slot>
          </Col>
          <Button size="md" @click="drawer = false">
            <Icon size="lg" :icon="FunnelIcon"></Icon>
            <span>{{ app.texts.filter.title }}</span>
          </Button>
        </Col>
      </Drawer>
    </Col>
  </div>
  <div class="hidden sm:block">
    <Col gap="md">
      <slot name="search"></slot>
      <slot name="filters"></slot>
    </Col>
  </div>
</template>

<script setup lang="ts">
import { app } from "@/app.context";
import Drawer from "@/components/Drawer.vue";
import FilterButton from "@/views/components/filters/FilterButton.vue";
import { FunnelIcon } from "@heroicons/vue/24/outline";
import { ref } from "vue";

const drawer = ref(false);
</script>
